import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import { FOODIE_SERVICE } from '../EndPoints';

export const GetColorFoodie = createAsyncThunk('employeeFoodie/getColorFoodie', async () => {
    const response = await apiInstance
        .get(FOODIE_SERVICE.getColorFoodie)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetSecurityLogs = createAsyncThunk(
    'employeeFoodie/getSecurityLogs',
    async (userId, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`${FOODIE_SERVICE.getSecurityLogs}${userId}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const GetFirstFoodieSetting = createAsyncThunk('employeeFoodie/getFirstFoodieSetting', async () => {
    const response = await apiInstance
        .get(FOODIE_SERVICE.getFirstFoodieSetting)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetAllFoodieDepartment = createAsyncThunk('employeeFoodie/getAllFoodieDepartment', async () => {
    const response = await apiInstance
        .get(FOODIE_SERVICE.getAllFoodieDepartment)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetFoodieDepartmentById = createAsyncThunk('employeeFoodie/getFoodieDepartmentById', async (params) => {
    const response = await apiInstance.get(`${FOODIE_SERVICE.getFoodieDepartmentById}${params}`).then((response) => {
        return response;
    })
        .catch((error) => {return error.response; });
    const { data, status } = response;
    return { data, status };
});
export const GetAllFoodieDevices = createAsyncThunk('employeeFoodie/getAllFoodieDevices', async () => {
    const response = await apiInstance
        .get(FOODIE_SERVICE.getAllFoodieDevices)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetFoodieRecordById = createAsyncThunk(
    'employeeFoodie/getFoodieRecordById',
    async (id, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`${FOODIE_SERVICE.getFoodieRecordById}${id}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const CreatesFoodieRecord = createAsyncThunk('employeeFoodie/createsFoodieRecord', async (params) => {
    const response = await apiInstance
        .post(FOODIE_SERVICE.createsFoodieRecord)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreatesFoodieDepartment = createAsyncThunk('employeeFoodie/createsFoodieDepartment', async (params) => {
    const response = await apiInstance
        .post(FOODIE_SERVICE.createsFoodieDepartment, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const AddDeviceToListFoodie = createAsyncThunk(
    'employeeFoodie/addDeviceToListFoodie',
    async (deviceId, { dispatch, getState }) => {
        const result = await apiInstance
            .post(`${FOODIE_SERVICE.addDeviceToListFoodie}${deviceId}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
export const UpdateFoodieDepartment = createAsyncThunk('employeeFoodie/updateFoodieDepartment', async (params) => {
    const response = await apiInstance
        .put(FOODIE_SERVICE.updateFoodieDepartment, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
// change the time or checkbox payroll
export const UpdateFoodieSettingColor = createAsyncThunk(
    'employeeFoodie/updateFoodieSettingColor',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .put(FOODIE_SERVICE.updateFoodieSettingColor, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
export const RemoveDeviceFoodie = createAsyncThunk(
    'employeeFoodie/removeDeviceFoodie',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .post(FOODIE_SERVICE.removeDeviceFoodie, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);

export const UpdateSettingsRestrictions = createAsyncThunk(
    'employeeFoodie/updateSettingsRestrictions',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .put(FOODIE_SERVICE.updateSettingsRestrictions, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
export const UpdateFoodieRecordById = createAsyncThunk(
    'employeeFoodie/updateFoodieRecordById',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .put(FOODIE_SERVICE.updateFoodieRecordById, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
